import { ApiRetailerPaymentType } from '@vend/types'
import {
  ReduxCurrentSale,
  selectCurrentSale,
} from '../../../../state/slices/currentSale/currentSaleSlice'
import { isPayPalEcomPaymentType } from '../../../../functions/payment-types/paypalEcom'
import { useAppSelector } from '../../../../state/hooks'

type EcomPaymentType = {
  paypalEcomPaymentType?: ApiRetailerPaymentType
}

const getPaypalEcomPaymentTypeFromSale = (
  sale: ReduxCurrentSale
): ApiRetailerPaymentType | undefined => {
  const paypalPaymentType = sale.originalSalePayments.find(payment =>
    isPayPalEcomPaymentType(
      payment.paymentType.type_id,
      payment.paymentType.name
    )
  )

  if (paypalPaymentType) {
    return paypalPaymentType.paymentType
  }
}

export const useEcomPaymentTypes = (): EcomPaymentType => {
  const sale = useAppSelector(selectCurrentSale)
  const paypalEcomPaymentType = getPaypalEcomPaymentTypeFromSale(sale)

  return {
    paypalEcomPaymentType,
  } as EcomPaymentType
}
